/** A source of random numbers in [0, 1). Game logic never calls Math.random directly. */
export interface Rng {
  next(): number;
}

/** mulberry32: small, fast, good enough for a maths game, and reproducible from a seed. */
export function seededRng(seed: number): Rng {
  let a = seed >>> 0;
  return {
    next() {
      a = (a + 0x6d2b79f5) >>> 0;
      let t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
}

export const mathRandomRng: Rng = { next: () => Math.random() };

/** Integer in [a, b] inclusive. */
export function randInt(rng: Rng, a: number, b: number): number {
  return a + Math.floor(rng.next() * (b - a + 1));
}

export function pick<T>(rng: Rng, items: readonly T[]): T {
  if (items.length === 0) throw new Error("pick from empty list");
  return items[randInt(rng, 0, items.length - 1)] as T;
}
